import withAemIntegration from "../../../withAemIntegration";
import Cookies from 'js-cookie'
import { useEffect } from 'react';
import env from "@lexus.com/ui/dist/utilities/env";


const ComponentEditConfig = {
    emptyLabel: "Login Federate Identity",
    isEmpty: function (props) {
        return !props || !props.title || props.title.trim().length < 1;
    },
};

const FederateIdentity = (props) => {
    const { tokenURL } = props.authConfig;
    const authConfig = {
        ...props.authConfig,
        // redirectURI: '/drivers',
        // redirectHost: 'http://local.aem.lexus.com:4502',
        // redirectURI: '',
        grantType: 'authorization_code'

    }

    useEffect(() => {
        if (window?.pkce) {
            window.pkce?.signInToken(authConfig, tokenURL, '.lexus.com', env('REACT_APP_ENV') !== 'prod' ? 'dev' : 'prod')
                .then((resp) => {
                    if (resp.state || resp.token) {
                        Cookies.set('LoggedIn', true);
                        Cookies.remove("id_token", { path: "/", domain: authConfig.cookieDomain });
                        Cookies.set('id_token', resp.token, { path: "/", domain: authConfig.cookieDomain, secure: true, expires: 1 / 24 })

                        if (resp.state) {
                            window.location = resp.state;
                        } else {
                            window.location = env('REACT_APP_DRIVERS_BASE_URL') ? `/${env('REACT_APP_DRIVERS_BASE_URL')}` : '/drivers'
                        }
                    }
                }).catch((e) => {
                    window.location = '/error'
                })
        }

    }, [window?.pkce])
    return <div></div>;
};

export default withAemIntegration("lexus/components/login/federate-identity")(FederateIdentity, ComponentEditConfig);
